import React from 'react'
import { makeStyles } from '@material-ui/core'
import { FormField } from '../index'
import { t as i18n } from 'ttag'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  emailField: {
    display: 'none'
  }
}))

const EmailField = props => {
  const classes = useStyles()
  const { onChange, value, inputRef, errors } = props

  return (
    <FormField
      className={classes.emailField}
      id={`Username-${props.id}`}
      data-cid='Username-root'
      autoComplete='username'
      label={i18n`Username`}
      name='username'
      onChange={onChange}
      value={value}
      errors={errors}
      inputRef={inputRef}
      required
    />
  )
}

EmailField.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  errors: PropTypes.any
}

export default EmailField
